module.exports = __webpack_public_path__ + "img/kommune-441.c72ad221.svg";